import { useClasser } from "@code-hike/classer";
import * as React from "react";
import { useSandpackNavigation } from "../../hooks/useSandpackNavigation";
import { RefreshIcon } from "../../icons";
export const RefreshButton = ({ clientId }) => {
    const { refresh } = useSandpackNavigation(clientId);
    const c = useClasser("sp");
    return (React.createElement("button", { className: c("button", "icon-standalone"), onClick: refresh, title: "Refresh Sandpack", type: "button" },
        React.createElement(RefreshIcon, null)));
};
//# sourceMappingURL=RefreshButton.js.map